(() => {
  if (window.rnoRecentViewedReady) return;
  window.rnoRecentViewedReady = true;

  const STORAGE_KEY = 'rno-recently-viewed';
  const LIMIT = 8;

  const readItems = () => {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY);
      return value ? JSON.parse(value) : [];
    } catch (error) {
      return [];
    }
  };

  const writeItems = (items) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, LIMIT)));
    } catch (error) {
      // Ignore private-mode write failures.
    }
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const productRoot = document.querySelector('[data-rno-recent-product]');
  if (productRoot) {
    const current = {
      handle: productRoot.dataset.handle,
      url: productRoot.dataset.url,
      title: productRoot.dataset.title,
      image: productRoot.dataset.image,
      price: productRoot.dataset.price,
    };
    const items = readItems().filter((item) => item.handle !== current.handle);
    items.unshift(current);
    writeItems(items);
  }

  const list = document.querySelector('[data-rno-recent-list]');
  if (!list) return;

  const currentHandle = productRoot ? productRoot.dataset.handle : '';
  const items = readItems().filter((item) => item.handle && item.handle !== currentHandle).slice(0, 4);

  if (!items.length) {
    const section = list.closest('[data-rno-recent-section]');
    if (section) section.hidden = true;
    return;
  }

  list.hidden = false;
  list.innerHTML = items
    .map(
      (item) => `
        <li>
          <a class="rno-recent__card" href="${escapeHtml(item.url)}">
            <div class="rno-recent__media">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="400" height="400" loading="lazy">` : ''}
            </div>
            <h3 class="rno-recent__title h5">${escapeHtml(item.title)}</h3>
            <p class="rno-recent__price">${escapeHtml(item.price)}</p>
          </a>
        </li>
      `
    )
    .join('');
})();
